module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Memorer tallene i riktig rekkefølge"},"en":{"title":"Memorize numbers in the right order"}}')
  delete Component.options._Ctor
}
